import set from 'lodash/set';

/**
 * Vue 2 SFCs usually set `name` (e.g. form-control); `_componentTag` is often undefined.
 * Normalise so Form / FormGroup wrapping matches flat model keys like `address_return.street`.
 */
function componentSlug(child) {
  const raw = child.$options.name || child.$options._componentTag || '';
  return String(raw).toLowerCase().replace(/-/g, '');
}

function isFormGroup(child) {
  return componentSlug(child) === 'formgroup';
}

function isFormControl(child) {
  return componentSlug(child) === 'formcontrol';
}

const getFormComponentTree = component => {
  let tree = {}
  for (let i = 0; i < component.$children.length; i++) {
    const child = component.$children[i];
    let groupName = ''

    if (isFormGroup(child)) {
      groupName += (child.$options.propsData && child.$options.propsData.name) || '';
    }

    if (isFormControl(child)) {
      const parent = child.$parent;
      const controlName =
        parent && parent.$options && parent.$options.propsData
          ? parent.$options.propsData.name
          : undefined;
      if (controlName != null && controlName !== '') {
        const prefix = groupName ? groupName + '.' : groupName;
        set(tree, prefix + controlName, child);
      }
    } else if (child?.$children?.length) { // If not coming across a FormControl, check if the component has any children
      const childTree = getFormComponentTree(child); // Repeat this

      if (childTree) {
        const prefix = groupName ? (groupName + '.') : groupName

        for (const name in childTree) {
          if (childTree.hasOwnProperty(name)) {
            set(tree, prefix + name, childTree[name])
          }
        }
      }
    }
  }
  return tree;
}


export default getFormComponentTree;
